import { jsxs } from 'react/jsx-runtime';
import classNames from '../../../../../../classnames/index.js';
import { forwardRef } from 'react';
import { getTestLabels } from '../../utils/getTestLabels.js';
import style from './Anchor.module.scss.js';

const { componentTestLabel } = getTestLabels('Anchor');
/**
 * **[source code](https://src.private.zooplus.net/projects/FE/repos/ui-components/browse/src/components/Anchor/Anchor.tsx)**
 *
 * @param {React.ReactNode} iconLeft - (optional) An SVG icon to show before the link text.
 * @param {React.ReactNode} iconRight - (optional) An SVG icon to show after the link text.
 * @param {boolean} isActive - (optional) Active state. Works only with `isBold` or `variant="neutral"`.
 * @param {boolean} isBold - (optional) Makes the text **bold**.
 * @param {boolean} isDisabled - (optional) Functionally and visually disables the anchor.
 * @param {string} size - (optional) One of `normal` (default), `small`, or `large`.
 * @param {boolean} underline - (optional) Whether or not the anchor is underlined by default. When hovering, this will be reversed.
 * @param {string} variant - (optional) One of `primary` (default), ~~`base`~~ (deprecated alias to `primary`), `danger`, ~~warning~~, (deprecated alias to `danger`), `neutral`, ~~`grey`~~ (deprecated alias to `neutral`), `inverse` or ~~`light`~~ (deprecated alias to `inverse`).
 */
const Anchor = forwardRef((props, ref) => {
    const { children, className, iconLeft, iconRight, isActive = false, isBold = false, isDisabled, size = 'normal', underline, variant: initialVariant = 'base', ...otherProps } = props;
    const variant = initialVariant === 'grey'
        ? 'neutral'
        : initialVariant === 'warning'
            ? 'danger'
            : initialVariant === 'light'
                ? 'inverse'
                : initialVariant;
    return (jsxs("a", { "data-zta": componentTestLabel, ref: ref, ...otherProps, className: classNames(style['z-anchor'], {
            [style['z-anchor--active']]: isActive,
            [style['z-anchor--bold']]: isBold,
            [style['z-anchor--disabled']]: isDisabled,
            [style[`z-anchor--${size}`]]: size !== 'normal',
            [style['z-anchor--underline']]: underline,
            [style[`z-anchor--${variant}`]]: variant !== 'base',
        }, className), "aria-disabled": isDisabled, children: [iconLeft?.({
                className: classNames(style['z-anchor__icon'], style['z-anchor__icon--left']),
            }), children, iconRight?.({
                className: classNames(style['z-anchor__icon'], style['z-anchor__icon--right']),
            })] }));
});
Anchor.displayName = 'Anchor';

export { Anchor };
//# sourceMappingURL=Anchor.js.map
